function helperGetDateTime (date) {
  return date.getTime()
}

module.exports = helperGetDateTime



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperGetDateTime.js
// module id = 48
// module chunks = 75